import { Injectable } from "@angular/core";

import { Observable } from "rxjs";

import { ApiRequestDispatcherService } from "../../../../shared-library/services/api/api-request-dispatcher.service";
import { ApiResponseDispatcherService } from "../../../../shared-library/services/api/api-response-dispatcher.service";

import { BaseSearchResultsModel } from "../../../models/base-search-results.model";
import { DirectoryItemModel } from "../models/directory-item.model";
import { SearchParametersModel } from "../models/search-parameters.model";

@Injectable({
    providedIn: "root"
})
export class DirectorySearchService {
    private readonly API_GET_LIST_URL = "/api/s4s-advanced-search/directory-search/get-list";

    public constructor(
        private _requestDispatcher: ApiRequestDispatcherService,
        private _responseDispatcher: ApiResponseDispatcherService
    ) {
    }

    public getSearchResults(searchParams: SearchParametersModel): Observable<BaseSearchResultsModel<DirectoryItemModel>> {
        const response$ = this._requestDispatcher.get<BaseSearchResultsModel<DirectoryItemModel>>(this.API_GET_LIST_URL, { searchParams: JSON.stringify(searchParams) });
        return this._responseDispatcher.unwrap(response$);
    }
}
